import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

function Layout() {
  return (
    <div className="flex h-screen overflow-hidden bg-white dark:bg-gray-900">
      <Sidebar />
      
      {/* Main Content - Responsive padding for sidebar */}
      <main className="flex-1 flex flex-col h-full w-full lg:ml-[80px] overflow-hidden">
        <Header />
        
        {/* Scrollable Content Area */}
        <div 
          className="flex-1 overflow-y-auto overflow-x-hidden px-2 sm:px-3 md:px-4 lg:px-6 py-2 sm:py-3 lg:py-4 bg-white dark:bg-gray-900 no-scrollbar" 
          style={{ backgroundColor: 'var(--md-sys-color-background)' }}
          id="scrollContainer"
        >
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default Layout;
